import xss, { IFilterXSSOptions } from 'xss';

// Isomorphic (runs in SSR and the browser) so server and client markup match.
const options: IFilterXSSOptions = {
  stripIgnoreTag: true,
  stripIgnoreTagBody: ['script', 'style'],
};

export const sanitizeHtml = (html?: string | null): string => {
  if (!html) return '';
  return xss(html, options);
};
